<template lang="pug">
v-layout(row justify-center)
  v-dialog(:value="value" persistent max-width="500")
    v-card
      title-bar(dark) Cancel Campaign
      v-card-text
        p This will cancel all the remaining scheduled campaign actions (email, text and task) immediately for
          | &nbsp;
          strong {{ description }}
          | . This action cannot be undone.
      v-card-actions
        v-spacer
        v-btn(flat @click="cancel") Don't Cancel
        v-btn.primary(@click="stop") Cancel Campaign
</template>

<script>
import TitleBar from '@/Core/components/TitleBar';

export default {
  name: 'StopCampaignModal',
  components: {
    TitleBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    amount: String,
  },
  data() {
    return {};
  },
  computed: {
    description() {
      const resource = this.amount === '1' ? 'contact' : 'contacts';
      return `${this.amount} ${resource}`;
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    stop() {
      this.$emit('stop');
    },
  },
};
</script>
